import React from 'react';
import { storyblokEditable } from '@storyblok/react';

const Footer = ({ blok }) => {
  const {
    company_name,
    copyright_text,
    social_links,
    footer_links,
    contact_info,
    newsletter_signup,
    background_color = '#1a1a1a',
    text_color = '#ffffff'
  } = blok;

  return (
    <footer 
      {...storyblokEditable(blok)}
      className="site-footer"
      style={{ 
        backgroundColor: background_color, 
        color: text_color 
      }}
    >
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Company Info Section */}
          <div className="footer-section company-info">
            <h3>{company_name}</h3>
            {contact_info && (
              <div className="contact-info">
                {contact_info.email && (
                  <p>Email: <a href={`mailto:${contact_info.email}`}>{contact_info.email}</a></p>
                )}
                {contact_info.phone && (
                  <p>Phone: <a href={`tel:${contact_info.phone}`}>{contact_info.phone}</a></p>
                )}
                {contact_info.address && (
                  <p>Address: {contact_info.address}</p>
                )}
              </div>
            )}
          </div>

          {/* Links Section */}
          {footer_links && footer_links.length > 0 && (
            <div className="footer-section links-section">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                {footer_links.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.url} 
                      target={link.target || '_self'}
                      rel={link.target === '_blank' ? 'noopener noreferrer' : ''}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Newsletter Signup */}
          {newsletter_signup && (
            <div className="footer-section newsletter-section">
              <h4>{newsletter_signup.title || 'Stay Connected'}</h4>
              <p>{newsletter_signup.description}</p>
              <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
                <input 
                  type="email" 
                  placeholder="Enter your email"
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-button">
                  Subscribe
                </button>
              </form>
            </div>
          )}

          {/* Social Links */}
          {social_links && social_links.length > 0 && (
            <div className="footer-section social-section">
              <h4>Follow Us</h4>
              <div className="social-links">
                {social_links.map((social, index) => (
                  <a 
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label={social.platform}
                  >
                    {social.icon ? (
                      <img src={social.icon} alt={social.platform} />
                    ) : (
                      <span>{social.platform}</span>
                    )}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="copyright">
            <p>
              {copyright_text || `© ${new Date().getFullYear()} ${company_name}. All rights reserved.`}
            </p>
          </div>
          <div className="footer-bottom-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/cookies">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;